/**
 * Wall-clock reading of the alert debounce (2026-10-30, owner report):
 * «событий подряд» counts EVALUATIONS, not minutes — a rule with «3 события
 * подряд» on an hourly check pages ~3 HOURS after the condition appears, not
 * in minutes. The drawer shows this conversion next to the input so the
 * cadence is never a surprise.
 */
export function debounceEta(fires: number, intervalSec: number): string {
  const seconds = fires * Math.max(1, intervalSec);
  if (seconds < 3600) return `≈ ${Math.max(1, Math.round(seconds / 60))} мин`;
  const hours = seconds / 3600;
  const whole = Math.round(hours * 10) / 10;
  return `≈ ${Number.isInteger(whole) ? whole : whole.toFixed(1)} ч`;
}
